import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { useQuery } from 'react-query'
import { endpoints } from '../../../api'
import SectionModal from '../../../handlers/user-profiles/patient-profile/components/summary/section-modal'

const WorksheetModal = ({ isOpen, patientId, worksheetScoreIds, onClose }) => {
  const { isLoading, data } = useQuery(
    [
      endpoints.getCheckInScoresForUser.getCacheId(),
      patientId,
      worksheetScoreIds
    ],
    () =>
      endpoints.getCheckInScoresForUser.request({
        id: patientId,
        module_type: 'treatment_activity',
        ids: worksheetScoreIds
      })
  )

  if (isLoading) return null

  return (
    <SectionModal
      treatmentData={data}
      isModalOpen={isOpen}
      handleModal={onClose}
      user_id={patientId}
      content="treatment"
      isDailyView
    />
  )
}

const ModalWrap = ({ history }) => {
  const { isOpen, patientId, worksheetScoreIds } = useStoreState(
    state => state.modals.worksheetScores
  )
  const { closeModal } = useStoreActions(state => state.modals.worksheetScores)

  useEffect(() => {
    closeModal()
  }, [history.location.pathname])

  if (!isOpen || !patientId) return null

  return (
    <WorksheetModal
      isOpen={isOpen}
      patientId={patientId}
      onClose={closeModal}
      worksheetScoreIds={worksheetScoreIds}
    />
  )
}

export default withRouter(ModalWrap)
